import * as ActionTypes from '../../constants/ActionTypes';
import API from '../../helpers/api';

export function getApplication(id) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_APPLICATION_BY_APPLICATION_ID_REQUEST,
			payload: {
				loading: true
			}
		});

		const response = await API.review_submission.getApplication(id);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_APPLICATION_BY_APPLICATION_ID_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
			return;
		}

		const { application } = response.data;

		dispatch({
			type: ActionTypes.GET_APPLICATION_BY_APPLICATION_ID_SUCCESS,
			payload: {
				application,
				loading: false
			}
		});
	};
}

export function submitApplication(id) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.SUBMIT_APPLICATION_REQUEST,
			payload: {
				loadingSubmit: true
			}
		});

		const response = await API.review_submission.submitApplication(id);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.SUBMIT_APPLICATION_ERROR,
				payload: {
					meta: response.meta,
					loadingSubmit: false
				}
			});
			return;
		}

		const { application } = response.data;

		dispatch({
			type: ActionTypes.SUBMIT_APPLICATION_SUCCESS,
			payload: {
				application,
				meta: response.meta,
				loadingSubmit: false
			}
		});
	};
}

export function resetApplicationPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_APPLICATION_PAGE
		});
	};
}

export function resetApplicationMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_APPLICATION_META
		});
	};
}